import api from '../utils/api';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function isBarnOwner() {
  try {
    const u = JSON.parse(localStorage.getItem('cr_user') || '{}');
    const bag = [u.primary_role, u.account_type, u.roles, u.role,
      u.user && u.user.primary_role, u.user && u.user.account_type, u.user && u.user.roles]
      .filter(Boolean).join(' ');
    return bag.includes('barn_owner') || bag.includes('platform_admin');
  } catch (e) { return false; }
}

const F = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <div style={{ fontSize: 10.5, letterSpacing: '0.08em', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
    {children}
  </div>
);

const BarnProfilePage = () => {
  const navigate = useNavigate();
  const [oid, setOid] = useState(null);
  const [logoUrl, setLogoUrl] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState({ name: '', phone: '', email: '', street: '', city: '', state: '', zip: '' });
  const set = (k) => (e) => setForm(prev => ({ ...prev, [k]: e.target.value }));

  useEffect(() => {
    let ok = true;
    const run = async () => {
      let org = null;
      for (const ep of ['/organizations/mine', '/organizations', '/memberships/mine']) {
        try {
          const r = await api.get(ep);
          const list = Array.isArray(r.data) ? r.data : (r.data.organizations || r.data.orgs || []);
          if (list.length) { const m = list.find(o => o.my_role === 'manager' || o.role === 'manager') || list[0]; org = m.organization || m; break; }
        } catch (e) {}
      }
      if (!org || !ok) { setLoaded(true); return; }
      try {
        const r = await api.get(`/organizations/${org.id}`);
        const d = (r.data && (r.data.organization || r.data)) || org;
        org = d.id ? d : org;
      } catch (e) {}
      if (!ok) return;
      setOid(org.id);
      setLogoUrl(org.logo_url || '');
      const loc = org.location || '';
      const m = loc.match(/^(.*?),\s*([A-Za-z]{2})\.?\s*(\d{5})?\s*$/);
      setForm({
        name: org.name || '', phone: org.phone || '', email: org.email || '',
        street: org.address || '',
        city: m ? m[1] : loc, state: m ? m[2].toUpperCase() : '', zip: (m && m[3]) || '',
      });
      setLoaded(true);
    };
    run();
    return () => { ok = false; };
  }, []);

  const save = async () => {
    if (!oid || saving) return;
    setSaving(true); setMsg('');
    const location = [form.city.trim(), [form.state.trim().toUpperCase(), form.zip.trim()].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    try {
      await api.put(`/organizations/${oid}`, {
        name: form.name.trim(), phone: form.phone.trim(), email: form.email.trim(),
        address: form.street.trim(), location,
      });
      setMsg('Saved \u2713');
    } catch (e) {
      setMsg('Could not save (' + ((e.response && e.response.status) || 'network') + ') \u2014 tell Claude');
    }
    setSaving(false);
  };

  if (!isBarnOwner()) return <div className="page-content"><div className="card" style={{ padding: 14, marginTop: 20 }}>Barn profile is available to barn owners and managers.</div></div>;
  if (!loaded) return <div className="loading-screen"><div className="spinner"></div></div>;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', paddingBottom: 90 }}>
      <div className="top-bar" style={{ padding: '18px 16px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <button onClick={() => navigate('/staff')} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: 20, padding: '4px 8px 4px 0' }}>&#8249;</button>
        <div>
          <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', margin: 0, fontWeight: 600 }}>{form.name || 'Your barn'}</p>
          <h1 style={{ color: 'white', fontSize: 24, margin: '3px 0 0' }}>Barn profile</h1>
        </div>
      </div>
      <div className="page-content">
        <div className="card" style={{ padding: 14, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ width: 58, height: 58, borderRadius: 12, background: 'var(--bg-secondary)', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            {logoUrl ? <img src={logoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: 22 }}>{'\ud83c\udfe0'}</span>}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 14 }}>Barn logo</div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Shows on your barn page and member views.</div>
          </div>
          <label className="btn btn-secondary btn-sm" style={{ cursor: 'pointer' }}>
            Upload
            <input type="file" accept="image/*" style={{ display: 'none' }} onChange={async (e) => {
              const file = e.target.files?.[0];
              if (!file || !oid) return;
              const fd = new FormData();
              fd.append('logo', file);
              try {
                const { data } = await api.put(`/organizations/${oid}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                setLogoUrl(data.logo_url || '');
                setMsg('Logo updated \u2713');
              } catch (err) { setMsg(err.response?.data?.message || 'Logo upload failed'); }
              e.target.value = '';
            }} />
          </label>
        </div>
        <div className="card" style={{ padding: 14, marginBottom: 12 }}>
          <F label="Barn name"><input className="form-input" value={form.name} onChange={set('name')} /></F>
          <F label="Phone"><input className="form-input" type="tel" value={form.phone} onChange={set('phone')} /></F>
          <F label="Email"><input className="form-input" type="email" value={form.email} onChange={set('email')} /></F>
        </div>
        <div className="card" style={{ padding: 14, marginBottom: 12 }}>
          <div style={{ fontFamily: 'var(--font-serif, Georgia)', fontSize: 15, marginBottom: 4 }}>Address</div>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 10 }}>Used in farrier and vet texts (with tap-for-directions) and as your default appointment location.</div>
          <F label="Street address"><input className="form-input" value={form.street} onChange={set('street')} placeholder="123 County Rd 456" /></F>
          <div style={{ display: 'flex', gap: 8 }}>
            <div style={{ flex: 2 }}><F label="City"><input className="form-input" value={form.city} onChange={set('city')} /></F></div>
            <div style={{ flex: 1 }}><F label="State"><input className="form-input" value={form.state} onChange={set('state')} maxLength={2} /></F></div>
            <div style={{ flex: 1 }}><F label="Zip"><input className="form-input" value={form.zip} onChange={set('zip')} /></F></div>
          </div>
        </div>
        <button className="btn btn-primary btn-full" style={{ borderRadius: 12, padding: 13 }} onClick={save} disabled={saving}>{saving ? 'Saving\u2026' : 'Save barn profile'}</button>
        {msg && <p style={{ textAlign: 'center', fontSize: 13.5, marginTop: 10, fontWeight: 600, color: msg.indexOf('\u2713') >= 0 ? '#1D9E75' : '#B4552E' }}>{msg}</p>}
      </div>
    </div>
  );
};

export default BarnProfilePage;
